import script from "./RedesSocialesFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesSocialesFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./RedesSocialesFormComponent.vue?vue&type=style&index=0&id=3c1670e4&scoped=true&lang=css"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1670e4"]])

export default __exports__